// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"253":"2f1b6864","323":"68c402c4","438":"43166c9f","866":"24672b52","942":"6f053573"}[chunkId] + ".chunk.js";
};